import { css } from '@emotion/core'
import { Button, Heading, HFlow, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { PageContainer } from 'components/layout/PageContainer'
import { ReactComponent as AvisoCidadaoCdsIcon } from 'images/cidadao/aviso-cidadao-cds.svg'
import { useState } from 'react'

import { ModalNovidadesAtividadeColetiva } from './ModalNovidadesAtividadeColetiva'

export function AlertNovidadesAtividadeColetiva() {
  const theme = useTheme()
  const styles = createStyles(theme)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const handleClose = () => setIsModalOpen(false)
  const handleOpen = () => setIsModalOpen(true)

  return (
    <PageContainer>
      <ModalNovidadesAtividadeColetiva isModalOpen={isModalOpen} onClose={handleClose} />
      <HFlow justifyContent='center'>
        <HFlow hSpacing={1} alignItems='center' style={styles.container}>
          <AvisoCidadaoCdsIcon css={styles.img} />
          <VFlow>
            <VFlow vSpacing={0.2} style={styles.text}>
              <Heading level={3}>O registro de Atividades coletivas evoluiu!</Heading>
              <Text>Para iniciar um novo registro, acesse o módulo de Atividade coletiva no menu lateral.</Text>
            </VFlow>
            <Button onClick={handleOpen} skin='outline' kind='primary' size='small'>
              Saiba mais
            </Button>
          </VFlow>
        </HFlow>
      </HFlow>
    </PageContainer>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    margin-top: 2rem;
    margin-bottom: 0.5rem;
    padding: 0.75rem 1.5rem;
    outline: 1px solid ${theme.pallete.gray.c60};
    background-color: ${theme.pallete.surface.main};
    border-radius: 0.4rem;
    min-height: 150px;
    width: 60rem;
    max-width: 100%;
  `,
  text: css`
    max-width: 55rem;
  `,
  img: css`
    align-self: flex-end;
    margin-bottom: -0.75rem;
  `,
})
